// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.envelope-editor,
.instrument-editor {
  display: flex;
  flex-direction: row;
  overflow: auto;
  flex-grow: 1;
}

.envelope-editor .waveform {
  flex: 1 1 auto;
}

.envelope-editor .envelope-controls,
.instrument-editor .instrument-controls {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 0 1 auto;
  align-self: stretch;
  background-color: #444;
  border-radius: 3px;
}

.instrument-editor .instrument-controls {
  flex: 1 1 auto;
}

.envelope-editor .waveform canvas.dragging {
  cursor: crosshair;
}

.envelope-editor .waveform canvas.moveable {
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
  cursor: -moz-grab;
}

.envelope-editor .waveform canvas.moveable:active {
  cursor: move;
  cursor: grabbing;
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
}

.control-group.pointbuttons {
  flex-direction: row;
}
`, "",{"version":3,"sources":["webpack://./src/components/instrument_editor/styles.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".envelope-editor,\n.instrument-editor {\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  flex-grow: 1;\n}\n\n.envelope-editor .waveform {\n  flex: 1 1 auto;\n}\n\n.envelope-editor .envelope-controls,\n.instrument-editor .instrument-controls {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  flex: 0 1 auto;\n  align-self: stretch;\n  background-color: #444;\n  border-radius: 3px;\n}\n\n.instrument-editor .instrument-controls {\n  flex: 1 1 auto;\n}\n\n.envelope-editor .waveform canvas.dragging {\n  cursor: crosshair;\n}\n\n.envelope-editor .waveform canvas.moveable {\n  cursor: move;\n  cursor: grab;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n}\n\n.envelope-editor .waveform canvas.moveable:active {\n  cursor: move;\n  cursor: grabbing;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n}\n\n.control-group.pointbuttons {\n  flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
